import { createMeshConfig } from "@baditaflorin/mesh-common";

export const config = createMeshConfig({
  appName: "Countdown Wall",
  description: "Create visible shared timers without a host or account.",
  accentHex: "#f97316",
  version: "0.1.0",
  commit: "main",
});
